import React, { forwardRef } from 'react';
import { Helmet } from 'react-helmet';
import SITE_SETTINGS from 'src/constants/whiteLabel';
import { IPage } from './types';

const Page = forwardRef<HTMLDivElement, IPage>(
    ({ children, title = '', className }, ref) => {
        return (
            <div ref={ref} className={className}>
                <Helmet>
                    <title>{title || SITE_SETTINGS.name}</title>
                </Helmet>
                {children}
            </div>
        );
    }
);

export default Page;
